import {Saseung3StatsService} from './saseung3-stats.service';

export const Saseung3StatsInjectables: Array<any> = [
  {
    provide: Saseung3StatsService,
    useClass: Saseung3StatsService,
  },
];
